import { FormControl, InputLabel, Container, Button, TextField, Box, Select, MenuItem, Card, CardContent } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import LogTheme from '../Layout/LogTheme';
import { useAuth } from '../../contexts/AuthContext';
import ImageUploader from '../Layout/ImageUploader';
import axios from 'axios';

function ChangeUser() {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [role, setUserRole] = useState('user');
  const [firstName, setFirstName] = useState(''); // Nytt
  const [lastName, setLastName] = useState(''); // Nytt
  const [bio, setBio] = useState(''); // Nytt
  const [profilePictures, setProfilePictures] = useState(null);
  const navigate = useNavigate();
  const [imagesToRemove, setImagesToRemove] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [uploadedImages, setUploadedImages] = useState([]);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(''); // Sätt ett initialt värde
  const [usersId, setUsersId] = useState(''); // Sätt ett initialt värde
  const { currentUser, userRole } = useAuth();

  useEffect(() => {
    // Lägg till en kontroll av att användaren är inloggad och har rollen admin
    if (userRole !== 'admin') {
      navigate('/'); // omdirigera till hemsidan
      // alternativt kan du visa ett felmeddelande här
    }
  }, [userRole, navigate]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_SERVER_URL}/api/users`)
      .then(response => {
        console.log('Response:', response); // Logga svaret
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        console.log('Data:', data); // Logga datan
        setUsers(data);
        setSelectedUser(data[0]._id);  // Välj den första användaren som standard
      })
      .catch(error => {
        console.error('Error:', error);
      });
  }, []);

  useEffect(() => {
    if (selectedUser) {
      fetch(`${process.env.REACT_APP_SERVER_URL}/api/showprofile/${selectedUser}`)
        .then(response => response.json())
        .then(data => {
          // Sätt state med data från servern
          setUsersId(data._id);
          setUsername(data.username);
          setEmail(data.email);
          setFirstName(data.firstName);
          setLastName(data.lastName);
          setBio(data.bio);
          setProfilePictures(data.profilePictures);
          setUserRole(data.role);
        })
        .catch(error => {
          console.error('Error:', error);
        });
    }
  }, [selectedUser]); // Kör useEffect när `selectedUser` ändras

  const handleRemoveExistingImage = (event, indexToRemove) => {
    event.preventDefault();
    let imageToRemove = profilePictures[indexToRemove];

    if (typeof imageToRemove === 'string') {
      imageToRemove = imageToRemove.replace('/profile-pictures/', '');
    }
    // Lägg till bilden i imagesToRemove
    setImagesToRemove(prevImages => [...prevImages, imageToRemove]);

    // Ta bort bilden från ProfilePictures-staten
    setProfilePictures(prevImages => prevImages.filter((image, index) => index !== indexToRemove));
  };

  const handleUploadSuccess = (files) => {
    setSelectedFiles(prevFiles => [...prevFiles, ...files]);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    // Upload the files
    try {
      const formData = new FormData();
      selectedFiles.forEach((file, index) => {
        formData.append(`file${index}`, file);
      });


      // Skicka en POST-begäran till /uploads/profile-pictures med den valda filen
      const uploadResponse = await axios.post(`${process.env.REACT_APP_SERVER_URL}/api/uploads/profile-pictures`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      // Kontrollera om filuppladdningen var framgångsrik
      console.log(uploadResponse.status);
      if (uploadResponse.status === 200) {
        console.log('Filen har laddats upp framgångsrikt. Filinformation:', uploadResponse.data);

        const imagePaths = uploadResponse.data.map(fileInfo => `/profile-pictures/${fileInfo.filename}`);

        // Lägg till de nya bilderna till profilePictures-arrayen
// Lägg till de nya bilderna till profilePictures-arrayen
const updatedImages = Array.isArray(profilePictures) ? [...profilePictures, ...imagePaths] : [...imagePaths];
        // Skapa ett objekt med uppdaterade data att skicka till servern
        const userData = {
          username,
          email,
          firstName,
          lastName,
          bio,
          profilePictures: updatedImages,
          role
        };

        // Om lösenordet inte är tomt, lägg till det i userData
        if (password.trim() !== '') {
          userData.password = password;
        }

        // Skicka en DELETE-begäran för varje bild i imagesToRemove
        imagesToRemove.forEach(imageToRemove => {
          fetch(`${process.env.REACT_APP_SERVER_URL}/api/deleteimage/${imageToRemove}`, {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ subDir: 'profile-pictures' })
          })
            .then(response => response.text())
            .then(data => {
              console.log(data);
            })
            .catch((error) => {
              console.error('Error:', error);
            });
        });
        console.log('userData: ', userData);
        //skicka till servern
        const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/changeprofile/${selectedUser}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(userData)
        });

        const data = await response.text();
        console.log(data);
        navigate(`/showprofile/${selectedUser}`); // Navigera till ShowProfile efter en lyckad uppdatering
      } else {
        console.error('Fel vid filuppladdning.');
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  return (
    <div>
      <LogTheme>
        <Container>
          <h2>Ändra konto</h2>
          <Box mb={2}>

            <FormControl variant="outlined" sx={{ minWidth: '350px' }}>
              <InputLabel id="user-select-label">Välj konto</InputLabel>
              <Select
                labelId="user-select-label"
                id="user-select"
                value={selectedUser || ''}
                onChange={(event) => setSelectedUser(event.target.value)}
                label="Välj konto"
              >
                {users.map((user) => (
                  <MenuItem key={user._id} value={user._id}>{user.username}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
          <form onSubmit={handleSubmit} >
            <Box mb={2}>
              <TextField
                type="text"
                label="Användarnamn"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                sx={{ minWidth: '350px' }}
              />
            </Box>
            <Box mb={2}>
              <TextField
                type="email"
                label="E-post"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                sx={{ minWidth: '350px' }}
              />
            </Box>
            <Box mb={2}>
              <TextField
                type="password"
                label="Lösenord"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                sx={{ minWidth: '350px' }}
              />
            </Box>
            {userRole === 'admin' && (
            <Box mb={2}>
              <Select
                value={role}
                onChange={(e) => setUserRole(e.target.value)}
                required
                sx={{ minWidth: '350px' }}
              >
                <MenuItem value={'admin'}>Admin</MenuItem>
                <MenuItem value={'user'}>User</MenuItem>
              </Select>
            </Box>
          )}
            <Box mb={2}>
              <TextField
                type="text"
                label="Förnamn"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                required
                sx={{ minWidth: '350px' }}
              />
            </Box>
            <Box mb={2}>
              <TextField
                type="text"
                label="Efternamn"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                required
                sx={{ minWidth: '350px' }}
              />
            </Box>
            <Box mb={2}>
              <TextField
                multiline
                rows={8}
                label="Skriv lite om båten och besättningen ..."
                value={bio}
                onChange={(e) => setBio(e.target.value)}
                sx={{ minWidth: '350px' }}
              />
            </Box>
            <Box mb={2}>
              <ImageUploader onUploadSuccess={handleUploadSuccess} />
              <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-around' }}>
                {uploadedImages.map((imageUrl, index) => (
                  <img key={index} src={imageUrl} alt="Uppladdad bild" style={{ width: '30%', height: 'auto', margin: '1%' }} />
                ))}
              </div>
            </Box>

            <Box display="flex" flexWrap="wrap" mx={-2}>
              {profilePictures && Array.isArray(profilePictures) && profilePictures.map((path, index) => (
                <Box key={index} width={300} mx={2}>
                  <Card sx={{ padding: 1, position: 'relative' }}>
                    <CardContent sx={{ padding: 2 }}>
                      <button onClick={(event) => handleRemoveExistingImage(event, index)}
                        style={{
                          position: 'absolute',
                          top: '0',
                          right: '0',
                          background: 'red',
                          color: '#fff',
                          border: 'none',
                          cursor: 'pointer'
                        }}
                      >X</button>

                      {path && typeof path === 'string' && (
                        <img src={path.replace('/profile-pictures/', `${process.env.REACT_APP_SERVER_URL}/api/profile-pictures/`)} alt="User" style={{ width: '100%' }} />
                      )}
                    </CardContent>
                  </Card>
                </Box>
              ))}

            </Box>

            <Box mt={2}>
              <Button type="submit" variant="contained">Skicka in</Button>
            </Box>

          </form>
        </Container>
      </LogTheme>
    </div>
  );
}

export default ChangeUser;